export const environment = {
  production: false,
  url: {
    adminLoginUrl: 'https://admin.mycarereport-uat.com/login',
    adminHome: 'https://admin.mycarereport-uat.com/',
    mcrUrl: 'https://mcr.mycarereport-uat.com/',
    api: 'https://api.mycarereport-uat.com/pps/',
    authUrl: 'https://auth.mycarereport-uat.com/',
    onlineResourcesStaticUrl: 'https://static.mycarereport-uat.com/',
    web_domain: 'mycarereport-uat.com'
  },
  urlGoogleAnalytics: 'UA-9486808-20',
  idleTime: {
    idle: 600,
    timeout: 60
  },
  posthogCode: '',
  posthogApiURL: '',
  posthog: {
    token: 'phc_6mYM1fjE16pWC8eCNQcvdE3MRCbom6fPeDuLiIjDkQw',
    config: {api_host: 'https://posthog.mycarereport2.com'}
  }
};